<template>
  <div v-if="ver">
    <div id="widgetCookiesPpal">
      <div class="widgetCookies">
        <h1 class="text-xl font-bold">
          {{ literal.componentCookiesTitle }}
        </h1>
        <div class="widgetCookiesOptions text-bold">
          <input
            @change="Ppal"
            v-model="principal"
            type="checkbox"
            value="checkedall"
          />
          {{ literal.componentCookiesChkPpal }}
          <ul>
            <li v-for="tipo in tiposCookie" :key="tipo.type">
              <input type="checkbox" v-model="tipo.isChecked" />
              {{ literal[tipo.item] }}
            </li>
          </ul>
        </div>
        <div class="widgetCookiesButtons">
          <button @click="accion(true)">
            {{ literal.componentCookiesAcceptAll }}</button
          ><button @click="accion(false)" value="">
            {{ literal.componentCookiesAcceptSel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LITERAL_COOKIES from "@/config/literales_cookie.json";
import { IDTERMINAL } from "@/config/setup";
export default {
  mounted() {
    const cookieNombre = IDTERMINAL + "cookies";
    let hayCookie = this.$cookie.get(cookieNombre);

  // console.log("COokie", hayCookie);
  // console.log(this.$route.query.cookie);
    if (this.$route.query.cookie) {
      hayCookie = false;
    }

    this.ver = hayCookie ? false : true;
  },
  data() {
    return {
      ver: true,
      principal: false,
      defaultCookie: { 0: "S", 1: "S", 2: "S" },
      tiposCookie: [
        {
          type: 1,
          isChecked: false,
          item: "tipoCookieAnalitycs",
          value:
            "Las cookies analíticas nos ayudan a mejorar nuestro sitio web mediante la recopilación y el reporte de información sobre su uso.",
          elements: [],
        },
        {
          type: 2,
          isChecked: false,
          item: "tipoCookieMarketing",
          value:
            "Las cookies de marketing se usan para realizar un seguimiento de los visitantes de los sitios web para permitir que los anunciantes muestren publicidad relevante.",
          elements: [],
        },
        {
          type: 0,
          isChecked: true,
          item: "tipoCookieUX",
          value:
            "Se puede almacenar o acceder a cookies, identificadores de dispositivo u otra información en su dispositivo para ayudar en la experiencia de usuario.",
          elements: [],
        },
      ],
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    literal() {
      const literales = LITERAL_COOKIES[this.locale]
        ? LITERAL_COOKIES[this.locale]
        : LITERAL_COOKIES["es"];

      return literales;
    },
    miCookie() {
      const cookie = {};
      this.tiposCookie.forEach(
        (e) => (cookie[e.type] = e.isChecked ? "S" : "N")
      );
      return cookie;
    },
  },
  methods: {
    Ppal() {
    // console.log(this.principal);
      if (this.principal) {
        this.tiposCookie.forEach((e) => (e.isChecked = true));
      } else {
        this.tiposCookie.forEach((e) => (e.isChecked = false));
      }
    },
    accion(valor) {
      const cookieNombre = IDTERMINAL + "cookies";
      const cookieContenido = valor
        ? JSON.stringify(this.defaultCookie)
        : JSON.stringify(this.miCookie);
    // console.log("valor", cookieContenido);
      this.$cookie.set(cookieNombre, cookieContenido, { expires: 5 });
      this.ver = !this.ver;
    },
  },
};
</script>

<style>
#widgetCookiesPpal {
  z-index: 9999;
}
</style>
